export const NOTSET = 'NotSet'

export const BookkeepingSystems = [
  NOTSET,
  'Fortnox',
  'Bokio',
  'Visma',
  'Annat',
] as const

export type BookkeepingSystem = (typeof BookkeepingSystems)[number]

export const bookkeepingSystemRegex = new RegExp(
  BookkeepingSystems.filter((value) => value !== NOTSET).join('|'),
)

export type FormValues = {
  orgNumber: string
  email: string
  bookkeepingSystem: BookkeepingSystem
  otherBookingSystem: string
  acceptPolicies: boolean
  subscriptionPlanName: string
}
